import { CroustilleElement } from "../lib";
import Cookies from 'js-cookie'

class NavigationContainer extends CroustilleElement {
  constructor() {
    super('navgiation-container');
  }

  get anchors() {
    return this.node.querySelectorAll('a');
  }

  init() {
    const position = Cookies.get('position')

    if (position && parseInt(position) > 0) {
      this.node.scrollTop = parseInt(position)
      Cookies.set('position', 0)
    }

    this.anchors.forEach(element => {
      if (element.href.indexOf('#') === -1) {
        element.addEventListener('click', (e) => {
          const s = this.node.scrollTop
          Cookies.set('position', s)
        })
      }
    });
  }
}

export default NavigationContainer;
